var _ellipse, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg6424A9F75Dc502132E9E5B39CommitmentIconDarkstudioXWebflowTemplate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 69,
    height: 56,
    viewBox: "0 0 69 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 53.4361,
    cy: 16.1555,
    rx: 15.127,
    ry: 15.1575,
    fill: "#FF7020"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.2544 20.9478L23.3981 36.1052L15.4834 28.5265",
    stroke: "white",
    strokeWidth: 1.62402,
    strokeLinecap: "square"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.369 53.428C41.6908 53.428 53.3009 41.7944 53.3009 27.4437C53.3009 13.093 41.6908 1.45947 27.369 1.45947C13.0471 1.45947 1.43701 13.093 1.43701 27.4437C1.43701 41.7944 13.0471 53.428 27.369 53.428Z",
    stroke: "white",
    strokeWidth: 1.62402,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg6424A9F75Dc502132E9E5B39CommitmentIconDarkstudioXWebflowTemplate);
export default __webpack_public_path__ + "static/media/6424a9f75dc502132e9e5b39_commitment-icon-darkstudio-x-webflow-template.1bee638dbb056376de38c9ec2764a572.svg";
export { ForwardRef as ReactComponent };